<template>
    <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="identificacion_juzgado" class="block text-sm font-medium text-gray-700">Identificación Juzgado</label>
            <input type="text" id="identificacion_juzgado" :value="loadData.identificacion_juzgado ? loadData.identificacion_juzgado : selectedData.identificacion_juzgado"
                @change="(newIdentificacionJuzgado) => $emit('updateValues', { 'identificacion_juzgado': newIdentificacionJuzgado.target.value })"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="nombre_juzgado" class="block text-sm font-medium text-gray-700">Nombre Juzgado</label>
            <input type="text" id="nombre_juzgado" :value="loadData.nombre_juzgado ? loadData.nombre_juzgado : selectedData.nombre_juzgado"
                @change="(newJuzgado) => $emit('updateValues', { 'nombre_juzgado': newJuzgado.target.value })"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="id_departamento" class="block text-sm font-medium text-gray-700">Departamento</label>
            <select id="id_departamento" :value="selectedDepartamentoId ? selectedDepartamentoId : selectedData.id_departamento"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(idDepartamentoNew) => { $emit('updateValues', { 'id_departamento': customUpdateValueData('id_departamento', idDepartamentoNew.target.value) }); selectedDepartamentoId = idDepartamentoNew.target.value }">
                <option value='' selected>Seleccione un Departamento...</option>
                <option v-for="(departamento, index) of collectionDepartamento" :key="'B' +index"
                    :value="departamento.id">{{
                        departamento.nombre
                    }}
                </option>
            </select>
        </div>
        <div  class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="id_municipio" class="block text-sm font-medium text-gray-700"> Municipio </label>
            <select  id="id_municipio" :value="loadData.id_municipio ? loadData.id_municipio : selectedData.id_municipio"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(idMunicipioNew) => { $emit('updateValues', { 'id_municipio': customUpdateValueData('id_municipio', idMunicipioNew.target.value)});}">
                <option value="" selected>Seleccione un Municipio...</option>
                <option
                    v-for="(municipio, index) of (view === 'crear') ? collectionMunicipio.filter(municipio => municipio.id_departamento === selectedDepartamentoId) 
                    : collectionMunicipio.filter(municipio => municipio.id_departamento === ((selectedDepartamentoId == '') ? selectedData.id_departamento : selectedDepartamentoId ))"
                    :key="'B' + index" :value="municipio.id">{{
                        `${municipio.nombre}`
                    }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'juzgadoCrearActualizarComponent',
    data: function () {
        return {
            selectedDepartamentoId: ''
        }
    },
    props: ['loadData', 'selectedData', 'collectionMunicipio', 'collectionDepartamento', 'customUpdateValueData', 'view'],
    emits: ["updateValues"],
    watch: {
        collectionMunicipio: {
            handler(newCollectionMunicipio) {
                if (this.loadData.id_municipio) {
                    const filteredMunicipio = newCollectionMunicipio.find(municipio => municipio.id === this.loadData.id_municipio.toString());
                    if (filteredMunicipio && filteredMunicipio.departamento) {
                        this.selectedDepartamentoId = filteredMunicipio.departamento.id;
                    }
                }  
            },
            deep: true
        }
    },
}
</script>